<template>
  <div class="payment-info">
    <div class="title">線上刷卡</div>
    <div class="mt-2">
      <p>
        我們採用的「藍新科技專業版線上金流」全程以全球最高、與銀行同等級的SSL128加密保護,最能保障您個人資料的傳輸安全,
        線上結帳期間將以亂碼型態加密直接傳送至銀行端進行認證授權,同時您的信用卡資料不會,請您安心付款。提供 Visa、
        Master card 及 JCB等三種信用卡付款方式,當您進入結帳流程後,您可以直接點選『線上付款』選項,將有信用卡付款視窗跳出,
        請填妥信用卡相關資料後,按下確認鍵並稍等數秒鐘,在獲得銀行授權後,即可完成付款手續。完成訂購手續後,會出現您本次訂購的訂單詳細資料,
        Loft29 Collection 建議您將該頁面列印下來,作為您訂購之依據。
      </p>
      <p class="mt-2 loft-text-lighlight">
        部份發卡銀行為保護卡片持有人的刷卡安全,因此在進行線上刷卡流程當中需多經過該發卡銀行『3D驗證』的步驟,這是ㄧ個一次性的驗證流程,
        完成後您的發卡銀行將會提供一組驗證密碼,經過此次驗證,您再次於我們網站或是其他網站刷卡消費將無須再次認證,僅需提供您的驗證密碼即可完成刷卡付款,
        驗證過程及密碼是直接連結至您的發卡銀行,並未經我們所使用的藍新線上刷卡機制,過程相當安全,請您放心使用。
      </p>
    </div>
    <div class="title mt-3">ATM轉帳/臨櫃匯款</div>
    <div class="mt-2">
      <p>在您確認訂單後,您可以在結帳的頁面點選『ATM轉帳/臨櫃匯款』,同時頁面下方將會出現我們的匯款資料:</p>
      <p class="loft-text-highlight">
        <span>帳戶:浩境國際有限公司<br></span>
        <span>銀行:兆豐國際商業銀行(017)金控總部分行<br></span>
        <span>帳號:201-09-08955-9</span>
      </p>
      <p>
        您可持任何一家銀行所發的金融卡,至離您最近的自動櫃員機轉帳付款或至任何一家銀行臨櫃匯款即可;
        同時我們也會寄送確認訂單之 E-mail 至您註冊時所填寫的電子郵件信箱中,並再次提醒您訂購內容、
        金額、付款方式等項目。Loft29 Collection 保留最終接受訂單與否的權利。
      </p>
      <p>
        關於『藍新科技專業版線上金流』: 全台第一家接受 VISA 國際組織駐點稽核的第三方金流服務業者、
        兩度榮獲經濟部商業司認定為電子商務交易履約保障機制的示範廠商-『藍新科技專業版線上金流』,
        刷卡資料採用 Entrust 128bits SSL 電子安全機制,將刷卡資料以亂碼形式加密,並直接與銀行連線傳輸,
        Loft29 Collection 網站本身不經手或儲存您的信用卡資料;同時由 VISA提供的Verified By VISA 3D
        Secure (VBV) 加密安全驗證機制與 Master 國際信用卡組織SecureCode、CVC2 (末三碼驗證) 安全認證機制
        透過持卡人向銀行申請刷卡密碼,透過這一層驗證程序更能確保卡片持有人的用卡安全。
      </p>
      <p>
        <img src="@/assets/img/mastercard-visa-secure.png">
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentInfo'
}
</script>

<style scoped>
.title {
  font-size: 1.2rem;
  font-weight: 700;
  font-family: 'Noto Serif TC', serif;
}
img {
  height: 50px;
}
</style>
